var _style, _defs, _polygon, _polygon2, _rect, _path, _line, _line2, _line3, _line4, _polyline, _defs2, _defs3, _defs4, _defs5, _polyline2, _path2, _path3, _path4, _path5, _path6, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _g, _text, _g2, _text2, _g3, _text3, _text4, _g4, _text5, _g5, _text6, _g6, _g7, _g8, _text7, _g9, _text8, _g10, _text9, _text10, _g11, _text11, _g12, _text12, _g13, _text13, _line5, _line6, _line7, _line8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganigramme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 999.3 705.3",
    style: {
      enableBackground: "new 0 0 999.3 705.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000095331781404192923580000005596060829760341680_);}\r\n\t.st1{fill:url(#SVGID_00000086655631761320178820000008026883686808994197_);}\r\n\t.st2{fill:url(#SVGID_00000017510037165349552890000004823554954683980951_);}\r\n\t.st3{fill:url(#SVGID_00000178166195841786284790000005676805564402151835_);}\r\n\t.st4{fill:url(#SVGID_00000116927479211616778400000015719424713823593616_);}\r\n\t.st5{fill:#00373A;}\r\n\t.st6{fill:url(#SVGID_00000147216105189349239330000007255912518510546855_);}\r\n\t.st7{fill:url(#SVGID_00000016760588312901229450000003632605720003363207_);}\r\n\t.st8{fill:#FFFFFF;}\r\n\t.st9{fill:#1E1E1C;}\r\n\t.st10{fill:none;stroke:#1E1E1C;stroke-width:0.5;}\r\n\t.st11{clip-path:url(#SVGID_00000006691270195233115440000015158734114093510810_);}\r\n\t.st12{clip-path:url(#SVGID_00000142898969812020027790000010151507764292704661_);}\r\n\t.st13{clip-path:url(#SVGID_00000060007793987702576120000007385834094459120543_);}\r\n\t.st14{clip-path:url(#SVGID_00000042696307861418792290000014258387741327329433_);}\r\n\t.st15{fill:none;stroke:#1E1E1C;stroke-width:0.4765;}\r\n\t.st16{clip-path:url(#SVGID_00000176755639415320893290000012301070140155558304_);}\r\n\t.st17{clip-path:url(#SVGID_00000065767076903660795130000006456135852528462985_);}\r\n\t.st18{clip-path:url(#SVGID_00000122691551637152652370000018190860534857174662_);}\r\n\t.st19{clip-path:url(#SVGID_00000128458086732957814550000006455023776079926460_);}\r\n\t.st20{clip-path:url(#SVGID_00000055689381843525864530000002001484569491273150_);}\r\n\t.st21{clip-path:url(#SVGID_00000033355606825230901890000012465675263604539272_);}\r\n\t.st22{clip-path:url(#SVGID_00000018238251149924981770000003362992129638942368_);}\r\n\t.st23{clip-path:url(#SVGID_00000041295123196454422560000015503356523579370415_);}\r\n\t.st24{clip-path:url(#SVGID_00000129903383584487282180000007987648693813094785_);}\r\n\t.st25{clip-path:url(#SVGID_00000111893494527118112430000000499118188264846470_);}\r\n\t.st26{clip-path:url(#SVGID_00000075147601092859174110000009311207032356816796_);}\r\n\t.st27{clip-path:url(#SVGID_00000133509952394663647890000000103398872946328964_);}\r\n\t.st28{font-family:'SolexRegular';}\r\n\t.st29{font-size:16px;}\r\n\t.st30{font-family:'SolexMedium';}\r\n\t.st31{font-size:18px;}\r\n\t.st32{font-family:'Calibri-Bold';}\r\n\t.st33{font-size:9.96px;}\r\n\t.st34{enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0.5,
    width: 999.5,
    height: 704.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163060054545770802080000007096519417557314703_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163060054545770802080000007096519417557314703_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168825088431406269040000001991077890935914133_",
    gradientUnits: "userSpaceOnUse",
    x1: -22,
    y1: 355.35,
    x2: 1001.2,
    y2: 355.35,
    gradientTransform: "matrix(1 0 0 -1 0 708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#30A4CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1497,
    style: {
      stopColor: "#47ABC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4646,
    style: {
      stopColor: "#83BCB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9152,
    style: {
      stopColor: "#E1D79F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4DC9A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: 0.1,
    style: {
      fill: "url(#SVGID_00000168825088431406269040000001991077890935914133_)"
    },
    width: 1023.2,
    height: 705.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138552812193850320700000002002974976329098927_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.5,
    y1: 2.5,
    x2: 399.5,
    y2: 709.7,
    gradientTransform: "matrix(1 0 0 -1 0 708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#30A4CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1497,
    style: {
      stopColor: "#47ABC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4646,
    style: {
      stopColor: "#83BCB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9152,
    style: {
      stopColor: "#E1D79F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4DC9A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000138552812193850320700000002002974976329098927_)"
    },
    points: "-1.6,-1.7 800.6,-1.7  401.4,705.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144297967108015314520000015130882723993729722_",
    gradientUnits: "userSpaceOnUse",
    x1: 2318.1628,
    y1: 914.3239,
    x2: 2318.1628,
    y2: 914.3239,
    gradientTransform: "matrix(0 -0.7447 -1 0 1913.9238 2156.9358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4DC9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8877,
    style: {
      stopColor: "#30A4CC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144297967108015314520000015130882723993729722_)"
    },
    d: "M999.6,430.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101076911177580447180000017380865180976908717_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.5,
    y1: 333.3,
    x2: 452.5,
    y2: 333.3,
    gradientTransform: "matrix(1 0 0 -1 0 708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADBA80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2555,
    style: {
      stopColor: "#B0BC84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4821,
    style: {
      stopColor: "#B9C28E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    style: {
      stopColor: "#C8CCA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9054,
    style: {
      stopColor: "#DEDABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAE2C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101076911177580447180000017380865180976908717_)"
    },
    d: "M452.5,374.7"
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "401.3,705.7 1.5,705.7 200.5,353.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088091734608027371850000012259822981526917791_",
    gradientUnits: "userSpaceOnUse",
    x1: 899.2,
    y1: 361.1,
    x2: 899.2,
    y2: 711.7,
    gradientTransform: "matrix(1 0 0 -1 0 708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#30A4CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1497,
    style: {
      stopColor: "#47ABC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4646,
    style: {
      stopColor: "#83BCB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9152,
    style: {
      stopColor: "#E1D79F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4DC9A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000088091734608027371850000012259822981526917791_)"
    },
    points: "1000.1,-3.7 1000.1,346.9  798.3,-1.5  "
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "999.6,345.8 604.3,345.8 801,-2.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139975119672079209960000000610722507402684851_",
    gradientUnits: "userSpaceOnUse",
    x1: 806.9,
    y1: 221.15,
    x2: 1302,
    y2: 221.15,
    gradientTransform: "matrix(1 0 0 -1 0 708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#30A4CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1497,
    style: {
      stopColor: "#47ABC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4646,
    style: {
      stopColor: "#83BCB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9152,
    style: {
      stopColor: "#E1D79F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4DC9A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000139975119672079209960000000610722507402684851_)"
    },
    points: "1302,705 806.9,705  1053.3,268.7  "
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.9,
    y: 33.7,
    className: "st8",
    width: 929.4,
    height: 636.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5008",
    className: "st9",
    d: "M471.2,72.9h78v93.2h-78V72.9z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 710.6,
    y1: 166.2,
    x2: 549,
    y2: 166.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 549,
    y1: 73.8,
    x2: 710.6,
    y2: 73.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 321.3,
    y1: 73.8,
    x2: 479.3,
    y2: 73.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 479.3,
    y1: 166.2,
    x2: 321.3,
    y2: 166.2
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "504.5,503 504.5,257 504.5,181 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000152238718631612561340000007752779906271054732_",
    x: 380.3,
    y: 401.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127009556197347593130000011171513472197081479_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152238718631612561340000007752779906271054732_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127009556197347593130000011171513472197081479_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000136407413094366485500000005527508857480227216_",
    x: 380.3,
    y: 401.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016796664951556896000000011691398051927148974_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136407413094366485500000005527508857480227216_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016796664951556896000000011691398051927148974_)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000178197836979518169470000012017305467822886800_",
    x: 380.3,
    y: 401.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023982188016848642770000005526212227263450299_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178197836979518169470000012017305467822886800_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000023982188016848642770000005526212227263450299_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000080885310982386077290000010557866320413201310_",
    x: 380.3,
    y: 401.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134955568273371016080000002997029211884646315_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080885310982386077290000010557866320413201310_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000134955568273371016080000002997029211884646315_)"
    }
  }))))), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "773.7,261.6 773.7,215 574.7,215 436,215 237,215 237,261.6 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1662",
    className: "st8",
    d: "M502,92.6h4.8c0.4,0,0.7,0.3,0.7,0.7v14.2c0,0.4-0.3,0.7-0.7,0.7H502 c-0.4,0-0.7-0.3-0.7-0.7V93.3C501.3,92.9,501.6,92.6,502,92.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5009",
    className: "st8",
    d: "M521.6,131.6c-2.3,0-4.5-0.3-6.7-1.1l0,0c-0.8-0.3-1.7-0.4-2.6-0.4h-12.5 c0,9.3,1.4,11.1,5.9,11.1c2.6-0.1,5.1-1,7.1-2.5v5.7c-2.8,1.3-5.8,2-8.8,2.1c-6.1,0-10.1-2.6-10.2-16.4h-5c-0.2,0-0.2-0.1-0.2-0.3 v-4.1c0-0.2,0.1-0.3,0.2-0.3h5.2c0.7-9.3,3.9-12.5,10.6-12.5c6.1,0,9,2.8,9,10.4v1c2.5,1.3,5.2,2.1,8,2.1c2.4,0,4.4-1,4.4-4.9 c0-3.8-1.6-4.5-4.5-4.5c-4.8,0-9-1.4-9-9.9c0-7,3.7-9.2,9.4-9.2c2.6,0.1,5.3,0.7,7.7,1.6v5.8c-2.4-1.4-5.1-2.2-7.9-2.3 c-2.2,0-3.9,0.8-3.9,4.1c0,3.4,1.3,4.2,3.7,4.2c4.7,0,9.7,1.4,9.7,10.3C531.5,129.1,527.2,131.6,521.6,131.6z M504.5,117.6 c-3.4,0-4.4,2-4.6,7.7h8.2V124C508.1,119,507.4,117.6,504.5,117.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5008_1_",
    className: "st9",
    d: "M227.1,248.7h21.4v25.6h-21.4V248.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5008_3_",
    className: "st9",
    d: "M492.4,488.5h26.9v32.1h-26.9V488.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5008_2_",
    className: "st9",
    d: "M763.1,248.7h21.4v25.6h-21.4V248.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000163041102329777328070000006902322509493212597_",
    x: 365.8,
    y: 380.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096036045935942250670000015529898339269796513_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163041102329777328070000006902322509493212597_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000096036045935942250670000015529898339269796513_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000108274110697037995640000013815359975303413385_",
    x: 365.8,
    y: 380.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070105918087940102270000005188318601851612829_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108274110697037995640000013815359975303413385_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070105918087940102270000005188318601851612829_)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158022787235285298710000015988166819474801302_",
    x: 365.8,
    y: 380.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027596706356383480150000006924904012545527728_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158022787235285298710000015988166819474801302_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000027596706356383480150000006924904012545527728_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000171687619534272213290000004496612328088482184_",
    x: 365.8,
    y: 380.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098223473635442060070000014560456593686840972_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171687619534272213290000004496612328088482184_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000098223473635442060070000014560456593686840972_)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000081625052923675403080000009853158556094626183_",
    x: 365.8,
    y: 440.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151503951806408878400000017569156873363441329_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081625052923675403080000009853158556094626183_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000151503951806408878400000017569156873363441329_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000092447987761687405300000004513491439000001727_",
    x: 365.8,
    y: 440.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139273846875619590910000013577272072219790271_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092447987761687405300000004513491439000001727_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139273846875619590910000013577272072219790271_)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000093174790689677643140000005008029432985593237_",
    x: 365.8,
    y: 440.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120528287874129332620000003588333885424675224_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093174790689677643140000005008029432985593237_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120528287874129332620000003588333885424675224_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000098938302769569094880000004681138876649925808_",
    x: 365.8,
    y: 440.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137815828128632819560000011025864010055945913_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098938302769569094880000004681138876649925808_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137815828128632819560000011025864010055945913_)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000053519326476871033450000012432584267045919365_",
    x: 365.8,
    y: 317.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005256804339542122220000008311587024385093290_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053519326476871033450000012432584267045919365_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005256804339542122220000008311587024385093290_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000030464872802279959350000008687025081707111820_",
    x: 365.8,
    y: 317.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103958437876206970550000001391310934896450178_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030464872802279959350000008687025081707111820_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000103958437876206970550000001391310934896450178_)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155121772826759285190000004479821664366804667_",
    x: 365.8,
    y: 317.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080208620957791684820000004884506456339606198_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155121772826759285190000004479821664366804667_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080208620957791684820000004884506456339606198_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000031168634128448530660000008019418761365140404_",
    x: 365.8,
    y: 317.6,
    width: 1.8,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016060178980541036880000001134904196770192054_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031168634128448530660000008019418761365140404_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016060178980541036880000001134904196770192054_)"
    }
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 120.0238 541.8724)",
    className: "st28 st29"
  }, "Direction "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 80.6238 558.8724)",
    className: "st28 st29"
  }, "de la ma\xEEtrise d\u2019ouvrage"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 99.5062 587.8744)",
    className: "st9 st30 st31"
  }, "Olivier IMBERT")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 297.1644 541.8705)",
    className: "st28 st29"
  }, "Direction "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 248.5644 558.8705)",
    className: "st28 st29"
  }, "technique et r\xE9habilitation "))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 278.1615 587.8744)",
    className: "st9 st30 st31"
  }, "Yann MIGINIAC")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 480.9047 541.8705)",
    className: "st28 st29"
  }, "Direction "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 447.5047 558.8705)",
    className: "st28 st29"
  }, "de la gestion locative "))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 325.8597 573.8744)",
    className: "st8 st32 st33"
  }, "-")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 436.8578 587.8744)",
    className: "st9 st30 st31"
  }, "Christophe GERBENNE")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 645.4242 540.8705)",
    className: "st28 st29"
  }, "Direction"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 624.6243 557.8705)",
    className: "st28 st29"
  }, "territoriale Nord "))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 610.9094 588.8744)",
    className: "st9 st30 st31"
  }, "Agn\xE8s BENREKASSA")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 812.3469 540.8705)",
    className: "st28 st29"
  }, "Direction"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 794.547 557.8705)",
    className: "st28 st29"
  }, "territoriale Sud "))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 778.3801 588.8744)",
    className: "st9 st30 st31"
  }, "Florent GROSTEFAN")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 145.572 295.6555)",
    className: "st28 st29"
  }, "Direction des ressources humaines "))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 187.9199 316.3525)",
    className: "st9 st30 st31"
  }, "B\xE9n\xE9dicte LUERY"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 130.8399 349.6201)",
    className: "st34"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st28 st29"
  }, "Direction des syst\xE8mes d\u2019information "), /*#__PURE__*/React.createElement("tspan", {
    x: 48.5,
    y: 19.2,
    className: "st28 st29"
  }, "et services g\xE9n\xE9raux"))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 174.9045 391.2103)",
    className: "st9 st30 st31"
  }, "Djamel BEDOUHENE")), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 678.3685 295.933)",
    className: "st28 st29"
  }, "Direction financi\xE8re et comptable  "))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 730.2805 316.9369)",
    className: "st9 st30 st31"
  }, "Karin ABADIA ")), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 687.6587 369.3705)",
    className: "st28 st29"
  }, "Direction juridique et march\xE9s "))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 720.7738 390.3744)",
    className: "st9 st30 st31"
  }, "Brigitte PERRIN")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 722.8218 440.1849)",
    className: "st8 st32 st33"
  }, "-")), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 154.1166 440.183)",
    className: "st28 st29"
  }, "Direction de la communication "))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 175.2284 462.1869)",
    className: "st9 st30 st31"
  }, "Juliette ZYLBERBERG")), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 336.0663 143.3182)",
    className: "st30 st31"
  }, "Ga\xEBtan LE GRAVIER"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 370.7582 101.5218)",
    className: "st34"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st28 st29"
  }, "Mission"), /*#__PURE__*/React.createElement("tspan", {
    x: -41.3,
    y: 19.2,
    className: "st28 st29"
  }, "M\xE9thode et Innovation"))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 585.6732 143.3196)",
    className: "st30 st31"
  }, "Val\xE9rie de BREM"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 584.272 120.5233)",
    className: "st9 st28 st29"
  }, "Direction g\xE9n\xE9rale")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 319,
    y1: 304,
    x2: 708,
    y2: 304
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 319,
    y1: 377,
    x2: 708,
    y2: 377
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 319,
    y1: 448,
    x2: 504.7,
    y2: 448
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 67.4,
    y1: 504,
    x2: 929.1,
    y2: 504
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganigramme);
export default __webpack_public_path__ + "static/media/organigramme.96bb90643f0e191416e6b02d479bdc6a.svg";
export { ForwardRef as ReactComponent };